import {Component, OnDestroy, OnInit} from "@angular/core";
import {
  RegroupementPlatService
} from "../../../../../core/services/conditionnements/regroupement/regroupement-plat.service";
import {Subscription} from "rxjs";
import RegroupementPlatDTO from "../../../../../core/dtos/conditionnement/regroupement-plat-d-t-o";
import {PointDeLivraisonDTO} from "../../../../../core/dtos/point-de-livraison-d-t-o";
import {PointDeLivraisonService} from "../../../../../core/services/entities/point-de-livraison.service";
import {UtilsService} from "../../../../../core/utils/utils.service";
import {ConviveDTO} from "../../../../../core/dtos/convive-dto";
import {ToastService} from "../../../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../../core/constants";
import {Auth2Service} from "../../../../../core/services/security/auth2.service";
import {ConvivesService} from "../../../../../core/services/entities/convives.service";

@Component({
  selector: 'yo-regroupement-plat-plc-add-dialog',
  templateUrl: './regroupement-plat-plc-add-dialog.component.html',
  styleUrls: ['./regroupement-plat-plc-add-dialog.component.scss']
})

export class RegroupementPlatPlcAddDialogComponent implements OnInit, OnDestroy{

  subOpenDialog: Subscription;
  regroupementPlat: RegroupementPlatDTO;
  allPlc: PointDeLivraisonDTO[] = [];
  private subPlcs: Subscription;
  private subConvives: Subscription;
  convives: ConviveDTO[] = [];
  selectedPlc: number[]=[];
  displayDialog: boolean;
  selectedConvive: number[]=[];

  constructor(private regroupementPlatSvc: RegroupementPlatService,
              private pointDeLivraisonSvc: PointDeLivraisonService,
              private authSvc: Auth2Service,
              private utilSvc: UtilsService,
              private toastSvc: ToastService,
              private conviveSvc: ConvivesService) {
  }

  ngOnInit() {
    this.initSubOpenDialog();
    this.initPrestations();
  }


  ngOnDestroy() {
    this.utilSvc.unsubscribe(this.subPlcs);
    this.utilSvc.unsubscribe(this.subOpenDialog);
    this.utilSvc.unsubscribe(this.subConvives);
  }

  private initSubOpenDialog() {
    this.subOpenDialog = this.regroupementPlatSvc.subjectOpenAJoutPlc$.subscribe((res) => {
      if (res) {
        this.regroupementPlat = res;
        this.initPlc();
        this.displayDialog = true;
      }
    })
  }

  initPlc = (): void => {
    this.subPlcs = this.pointDeLivraisonSvc.findAllPlcListFromSite(this.regroupementPlat.uniteDeProduction.map(udp => udp.site.id)).subscribe(response => {
      this.allPlc = response.allPointLivraison;
    });
  }

  initPrestations = (): void => {
   this.subConvives = this.conviveSvc.findAll().subscribe(response => {
     if (response)
      this.convives = response.resultList;
    });
  }


  closeDialog() {
    this.displayDialog = false;
  }

  save() {
    this.regroupementPlatSvc.addPlcPrestation(this.selectedPlc, this.regroupementPlat.id, this.selectedConvive).subscribe((res) => {
      if (res.one) {
        if (res.one.updateError) {
          this.regroupementPlatSvc.announceErreurParametrage(res.one.erreurs)
          console.log("erreursannouced")
          this.closeDialog();
        } else {
          this.regroupementPlatSvc.announceRegroupementAddPlc();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Point de livraison ajouté avec succès`);
          this.closeDialog();
        }
      }
    })
  }

  updateSelectedPlc($event: any) {
    this.selectedPlc = $event
  }

  canEdit() {
    return this.authSvc.isSiteLocal(this.regroupementPlat.site.id);
  }

  updateSelectedConvive($event: any) {
    this.selectedConvive = $event
  }
}
